
import React from "react";
import FormField from "@/components/forms/FormField";
import FormTextArea from "@/components/forms/FormTextArea";
import CategorySelect from "@/components/forms/CategorySelect";
import { BusinessCategory } from "@/types";

interface BusinessInfoSectionProps {
  name: string;
  description: string;
  address: string;
  city: string;
  state: string;
  postcode: string;
  what3words: string;
  category: BusinessCategory | "";
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleCategoryChange: (value: string) => void;
  formErrors: Record<string, string>;
}

const BusinessInfoSection: React.FC<BusinessInfoSectionProps> = ({
  name,
  description,
  address,
  city,
  state,
  postcode,
  what3words,
  category,
  handleChange,
  handleCategoryChange,
  formErrors,
}) => {
  return (
    <>
      <FormField
        id="name"
        label="Business Name"
        required
        value={name}
        onChange={handleChange}
        error={formErrors.name}
      />

      <FormTextArea
        id="description"
        label="Description"
        required
        value={description}
        onChange={handleChange}
        error={formErrors.description}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          id="address"
          label="Address"
          value={address}
          onChange={handleChange}
          error={formErrors.address}
          placeholder="Optional street address"
        />

        <FormField
          id="city"
          label="City/Town"
          required
          value={city}
          onChange={handleChange}
          error={formErrors.city}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          id="state"
          label="County/Region"
          value={state}
          onChange={handleChange}
          error={formErrors.state}
          placeholder="e.g. Greater Manchester, London (can be same as city)"
        />

        <FormField
          id="postcode"
          label="Postcode"
          value={postcode}
          onChange={handleChange}
          error={formErrors.postcode}
          placeholder="Optional postcode"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          id="what3words"
          label="What3Words"
          value={what3words}
          onChange={handleChange}
          error={formErrors.what3words}
          placeholder="Optional what3words address"
        />

        <CategorySelect
          value={category}
          onChange={handleCategoryChange}
          error={formErrors.category}
          required
        />
      </div>
    </>
  );
};

export default BusinessInfoSection;
